module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo20-32064e297d29bc5456706d9e186834ff.jpg";